var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarDate2 = function SvgCalendarDate2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 96,
    height: 96,
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "calendar date 2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M1,45c0,1.10455,0.89545,2,2,2h42c1.10455,0,2-0.89545,2-2V15H1V45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E86C60",
    d: "M45,5H3C1.89545,5,1,5.89539,1,7v8h46V7C47,5.89539,46.10455,5,45,5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M10,10V2c0-0.55228,0.44771-1,1-1h2c0.55229,0,1,0.44772,1,1v8c0,0.55229-0.44771,1-1,1h-2 C10.44771,11,10,10.55229,10,10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M34,10V2c0-0.55228,0.44772-1,1-1h2c0.55228,0,1,0.44772,1,1v8c0,0.55229-0.44772,1-1,1h-2 C34.44772,11,34,10.55229,34,10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M40,34h-3v-6h3c0.55273,0,1-0.44727,1-1s-0.44727-1-1-1h-3v-5c0-0.55273-0.44727-1-1-1s-1,0.44727-1,1v5h-6 v-5c0-0.55273-0.44727-1-1-1s-1,0.44727-1,1v5h-6v-5c0-0.55273-0.44727-1-1-1s-1,0.44727-1,1v5h-6v-5c0-0.55273-0.44727-1-1-1 s-1,0.44727-1,1v5H8c-0.55273,0-1,0.44727-1,1s0.44727,1,1,1h3v6H8c-0.55273,0-1,0.44727-1,1s0.44727,1,1,1h3v5 c0,0.55273,0.44727,1,1,1s1-0.44727,1-1v-5h6v5c0,0.55273,0.44727,1,1,1s1-0.44727,1-1v-5h6v5c0,0.55273,0.44727,1,1,1 s1-0.44727,1-1v-5h6v5c0,0.55273,0.44727,1,1,1s1-0.44727,1-1v-5h3c0.55273,0,1-0.44727,1-1S40.55273,34,40,34z M13,34v-6h6v6H13z M21,34v-6h6v6H21z M29,34v-6h6v6H29z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarDate2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-date-2.9c5c9819.svg";
export { ForwardRef as ReactComponent };